module.exports = __webpack_public_path__ + "img/MobileLogin.ca49dc9e.gif";